import * as yup from 'yup';

export const reservationSchema = yup.object({
  roomType: yup.string().required('Room type is required'),
  roomNo: yup.string().required('Room Number is required'),

  checkInDate: yup.date().required('Check-In Date is required'),
  checkOutDate: yup.date().required('Check-Out Date is required'),
  // Antes era .integer(), lo que rechazaba silenciosamente cualquier precio
  // con decimales (ej. habitación a $21.50). El backend recibe el monto como
  // string formateado a 2 decimales vía reservationService.js, así que aquí
  // solo necesitamos asegurar que sea un número no negativo.
  advanceAmount: yup.number().min(0, 'El anticipo no puede ser negativo').required('Advance amount is required'),
  paymentMethod: yup.string().nullable().notRequired(),
  totalAmount: yup.number().min(0, 'El total no puede ser negativo'),
  customers: yup
    .array()
    .of(
      yup.object().shape({
        phoneNumber: yup.string(), // ❌ REMOVER .required()
        firstName: yup.string().required('First Name is required'), // ✅ MANTENER
        lastName: yup.string().required('Last Name is required'), // ✅ MANTENER
        email: yup.string().email('Invalid email format'), // ❌ REMOVER .required()
        idCardType: yup.string().notOneOf(['default'], 'ID Card Type is required'),
        idcardNumber: yup
          .string()
          .when('idCardType', {
            is: 'ID',
            then: yup.string().matches(/^([VE]-)?\d{6,9}$/, 'Formato inválido (ej: V-12345678 o 12345678)')
          })
          .when('idCardType', {
            is: 'Passport',
            then: yup.string().min(6, 'Mínimo 6 caracteres')
          })
          .when('idCardType', {
            is: 'Rif',
            then: yup.string().min(8, 'Mínimo 8 caracteres')
          })
          .when('idCardType', {
            is: 'DrivingLicense',
            then: yup.string().required('Driving License Number is required')
          })
          .required('ID Card Number is required'),
        address: yup.string().required('Address is required')
      })
    )
    .required('Must have customers')
    .min(1, 'Minimum of 1 customers')
  // phoneNumber: yup.string().required('Phone Number is required'),
  // firstName: yup.string().required('First Name is required'),
  // lastName: yup.string().required('Last Name is required'),
  // email: yup.string().email('Invalid email format').required('Email is required'),
  // idCardType: yup.string().notOneOf(['default'], 'ID Card Type is required'),
  // idcardNumber: yup
  //   .string()
  //   .when('idCardType', {
  //     is: 'Aadharcard',
  //     then: yup.string().matches(/^\d{12}$/, 'Aadharcard Number must be 12 digits')
  //   })
  //   .when('idCardType', {
  //     is: 'VoterIdCard',
  //     then: yup.string().matches(/^[A-Z]{3}[0-9]{7}$/, 'VoterIdCard Number must be in the format AAA1111111')
  //   })
  //   .when('idCardType', {
  //     is: 'PanCard',
  //     then: yup.string().matches(/^([A-Z]){5}([0-9]){4}([A-Z]){1}$/, 'PanCard Number must be in the format ABCDE1234F')
  //   })
  //   .when('idCardType', {
  //     is: 'DrivingLicense',
  //     then: yup.string().required('Driving License Number is required')
  //   })
  //   .required('ID Card Number is required'),
  // address: yup.string().required('Address is required'),
  // idFile: yup.mixed()
});
